import thunk from 'redux-thunk';
import { createLogger } from 'redux-logger';
import createHistory from 'history/createBrowserHistory';
import { routerMiddleware } from 'connected-react-router';
import { createStore, applyMiddleware, compose, type StoreEnhancer } from 'redux';
import * as ReselectTools from 'reselect-tools';
import createRootReducer from './rootReducer';
import initialState from './initialState';
import { initResizeListener } from './middleware/screenResize';
import { personalDetailsSelectors } from '../tabs/PersonalDetails/ducks';

export const history = createHistory({
  basename: process.env.CARVANA_APP_PUBLIC_URL
});

const middleware = [thunk, routerMiddleware(history)];

if (process.env.NODE_ENV !== 'production') {
  middleware.push(
    createLogger({
      level: 'info',
      collapsed: true
    })
  );
}

let preloadedState: unknown;
let devToolsEnhancer: StoreEnhancer | undefined;
if (typeof window !== 'undefined') {
  preloadedState = window.__PRELOADED_STATE__;
  if (typeof window.__REDUX_DEVTOOLS_EXTENSION__ === 'function') {
    devToolsEnhancer = window.__REDUX_DEVTOOLS_EXTENSION__() as StoreEnhancer;
  }
}

const composedEnhancers = devToolsEnhancer
  ? compose(applyMiddleware(...middleware), devToolsEnhancer)
  : applyMiddleware(...middleware);

export const generateStoreInstance = (appInitialState?: unknown) => {
  return createStore(
    createRootReducer(history),
    appInitialState || preloadedState || initialState,
    composedEnhancers
  );
};

const store = generateStoreInstance();

initResizeListener(store);

ReselectTools.getStateWith(() => store.getState());
ReselectTools.registerSelectors(personalDetailsSelectors);

export default store;
